{
  "sections": {
    "hero": "Portfolio",
    "about": "Sobre",
    "experience": "Experiência",
    "education": "Formação",
    "skills": "Habilidades",
    "projects": "Projetos",
    "talks": "Palestras",
    "contact": "Contato"
  },
  "hero": {
    "headline": "Desenvolvedora Front-end",
    "description": "Profissional de desenvolvimento web, construindo sites acessíveis e de alto desempenho com foco na experiência do usuário."
  },
  "about": {
    "headline": "Um pouco sobre mim",
    "paragraphs": [
      "Comecei a programar brincando com aplicativos de televisão digital em 2011, e desde então nunca parei. Tive a oportunidade de aprender uma variedade de linguagens na universidade, do C e C++ ao SML e VHDL, mas encontrei minha paixão no desenvolvimento web, onde posso combinar minha criatividade com minhas habilidades técnicas para criar experiências envolventes para os usuários.",
      "Tenho mais de {programming} anos de programação e {professional} anos de experiência profissional em desenvolvimento web com JavaScript/TypeScript, onde trabalhei com muitas tecnologias e frameworks, incluindo Vue, Angular, Nuxt e Astro. Também trabalhei ocasionalmente com tecnologias de back-end, como .NET Core, Django e Node."
    ]
  },
  "experience": [
    {
      "title": "Ecosia",
      "link": "https://ecosia.org",
      "duration": "abr 2021 - presente",
      "intro": "Engenheira Front-end",
      "description": "Atuando como engenheira front-end no motor de busca que planta árvores. Usando JavaScript com Vue, Nuxt e Vite, assim como HTML e SCSS para criar páginas web tanto estáticas quanto renderizadas pelo servidor. Avalio o desempenho e a acessibilidade dessas páginas, garanto sua integridade por meio de testes, e me certifico que proporcionamos excelentes experiências aos nossos usuários."
    },
    {
      "title": "Symbaros",
      "link": "https://symbaros.com.br",
      "duration": "ago 2020 - mar 2022",
      "intro": "Consultora",
      "description": "Atuação como consultora em arquitetura front-end para uma plataforma especializada em aluguel de espaços comerciais usando IA. Defini a tecnologia e a arquitetura do conjunto de páginas web, utilisando Vue.JS como base, e criei integrações com as APIs para obtenção de informações relativas à busca de bens imobiliários, assim como seus atributos."
    },
    {
      "title": "Questrade",
      "link": "https://www.questrade.com/home",
      "duration": "jun 2020 - dez 2020",
      "intro": "Engenheira Front-end",
      "description": "Atuação como engenheira front-end em uma plataforma financeira canadense especializada em trading, usando o framework Angular8+, TypeScript e SCSS para fornecer uma experiência performática e segura a seus usuários."
    },
    {
      "title": "Blip.ai",
      "link": "https://blip.ai",
      "duration": "jun 2019 - mai 2020",
      "intro": "Desenvolvedora Full Stack",
      "description": "Atuação como desenvolvedora full stack na plataforma de criação de chatbots BLiP.ai, utilizando os frameworks AngularJS e VueJS para o front-end, .NET core para o back-end, e Python para analisar modelos de Processamento de Linguagem Natural, além de criar uma API em Django para permitir consultas a modelos treinados."
    },
    {
      "title": "Blip.ai",
      "link": "https://blip.ai",
      "duration": "jan 2018 - mai 2019",
      "intro": "Estagiária em desenvolvimento",
      "description": "Atuação como estagiária em desenvolvimento na plataforma de criação de chatbots BLiP.ai utilizando os frameworks AngularJS e VueJS, fornecimento de soluções de inteligência artificial com Python e análises de modelos de Processamento de Linguagem Natural baseados em intenções e entidades."
    }
  ],
  "education": {
    "institution": "Universidade Federal de Minas Gerais (UFMG)",
    "year": "2021",
    "degree": "Bacharelado",
    "field": "Ciência da Computação"
  },
  "skills": {
    "programming": "Programação",
    "web": {
      "title": "Web",
      "set": [
        "Performance",
        "Acessibilidade",
        "Responsividade"
      ]
    },
    "frameworks": "Frameworks",
    "tools": "Ferramentas",
    "testing": "Testes",
    "databases": "Bancos de Dados",
    "languages": {
      "title": "Idiomas",
      "set": [
        "Inglês (Fluente)",
        "Português (Nativo)",
        "Francês (Competente)"
      ]
    }
  },
  "projects": [
    {
      "name": "Altomata",
      "image": "altomata.gif",
      "link": "https://altomata.github.io",
      "description": "Um simulador de autômatos celulares construído com VueJS e TypeScript, permitindo aos usuários criar e visualizar regras, padrões e evoluções de autômatos celulares."
    }
  ],
  "talks": [
    {
      "event": "The Developer's Conference",
      "link": "https://thedevconf.com/tdc/2019/belohorizonte/trilha-inteligencia-artificial",
      "date": "14 jun 2019",
      "title": "Word Embedding e Aplicação",
      "description": "Como desenvolver uma aplicação para um problema recorrente de Processamento de Linguagem Natural utilizando o Word Embedding? Exploração da tarefa de correção ortográfica."
    },
    {
      "event": "Developer Circle",
      "link": "https://devcbhmeetupfev2019.splashthat.com/",
      "date": "19 fev 2019",
      "title": "Como Aprender Usando Texto?",
      "description": "O uso de palavras em modelos matemáticos depende da sua transformação em representações exatas. Um algoritmo que pode fazer isso é o Word Embedding."
    }
  ],
  "read": "Ler",
  "contact": {
    "prompt": "Vamos conversar.",
    "description": "Se você representa uma organização sem fins lucrativos em busca de voluntários, ou faz parte de um grupo desfavorecido ou discriminado e precisa de mentoria, ficarei feliz em ajudar."
  },
  "footer": {
    "rights": "Todos os direitos reservados."
  }
}
